import { FileListProps } from '@procore/core-react/dist/_typedoc/FileList/FileList.types.json';
import * as React from 'react';
export default {
  FileListProps,
  React
};